import axios from "axios";

const apiDatosDocente = {
	async readDatosCuentaDocente() {           
		const response = await axios.get("/api/datoscuentauser");  
		return response.data;        
	},
	async getDatosCuentaDocente(noPlaza) {           
		const response = await axios.get("/api/datoscuentauser/"+noPlaza);  
		return response.data;        
	},
	async createDatosCuentaDocente(requestData) {
		const response = await axios.post("/api/datoscuentauser", requestData);
		return response.data;
	},
	async updateDatosCuentaDocente(noPlaza, requestData) {
		const response = await axios.put("/api/datoscuentauser/"+noPlaza, requestData);
		return response.data;
	},
	async deleteDatosCuentaDocente(noPlaza) {
		const response = await axios.delete("/api/datoscuentauser/"+noPlaza);
		return response.data;
	}
};

export default apiDatosDocente;
